import { updateImDfmFeedbackInfo_updateDfmFeedbackInfo } from '@Admin/AdminQuotingPage/ImDfmSlidesPanel/ImDfmSlide/ActiveSlide/__generated__/updateImDfmFeedbackInfo'

import { ImDfmSlideType } from '~/redux-modules/im-dfm/types'

import {
    IM_DFM_RESET,
    IM_DFM_SET_ACTIVE_SLIDE_ID,
    IM_DFM_SET_SHOULD_SYNC,
    IM_DFM_SET_SLIDES,
    IM_DFM_UPDATE_SLIDE,
} from './constants'

export const resetImDfmState = () => ({ type: IM_DFM_RESET } as const)

export const setActiveSlideId = (slideId: string) =>
    ({
        type: IM_DFM_SET_ACTIVE_SLIDE_ID,
        slideId,
    } as const)

export const setImDfmSlides = (slides: ImDfmSlideType[]) =>
    ({
        type: IM_DFM_SET_SLIDES,
        slides,
    } as const)

export const setShouldSync = (shouldSync: boolean) =>
    ({
        type: IM_DFM_SET_SHOULD_SYNC,
        shouldSync,
    } as const)

export const updateImDfmSlide = (
    slideData: updateImDfmFeedbackInfo_updateDfmFeedbackInfo | undefined,
) =>
    ({
        type: IM_DFM_UPDATE_SLIDE,
        slideData,
    } as const)
